import { constantRouterMap, factoryRoutes, dealerRoutes, counselorRouters, dealerRoutes2, dealerRoutes3, dealerRoutes4,dealerRoutes5, counselorRouters2 } from '@/router';

const permission = {
  state: {
    routes: [],
  },

  mutations: {
    SET_ROUTES: (state, routes) => {
      state.routes = constantRouterMap.concat(routes);
    }
  },

  actions: {
    //获取路由表
    generateRoutes({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        let accessedRoutes;
        console.log('传过来的用户信息===>', userInfo)
        if (userInfo.company.companyType.includes('集团')) {
          // console.log('路由表===>', factoryRoutes)
          factoryRoutes.forEach((item, index) => {
            if (item.path == '/target') {//业绩目标
              if (userInfo.roles.includes('工厂经理')) {
                let region = [
                  {
                    path: 'targetFatory',
                    name: 'targetFatory',
                    hidden: false,
                    component: () => import('@/views/target/factory'),
                    meta: {
                      title: '大区业绩目标'
                    },
                  },
                  {
                    path: 'targetDealer',
                    name: 'targetDealer',
                    hidden: false,
                    component: () => import('@/views/target/dealer'),
                    meta: {
                      title: '经销商业绩目标'
                    }
                  }
                ];
                if (userInfo.roles.includes('管理员')) {
                  let manager = {
                    path: 'targetManager',
                    name: 'targetManager',
                    hidden: false,
                    component: () => import('@/views/target/manager'),
                    meta: {
                      title: '业绩目标管理员'
                    }
                  };
                  region.push(manager);
                }
                item.children = region;
              } else {
                let dealer = {
                  path: 'targetDealer',
                  name: 'targetDealer',
                  hidden: false,
                  component: () => import('@/views/target/dealer'),
                  meta: {
                    title: '经销商业绩目标',
                    icon: 'total-week'
                  }
                };
                item.children.push(dealer);
              }
            }
            if (item.path == '/record') {//业绩目标
              if (!userInfo.roles.includes('工厂经理')) {
                factoryRoutes.splice(index, 1)
              }
            }
          })
          accessedRoutes = factoryRoutes || [];
        } else {
          if (userInfo.roles.length === 1 && userInfo.roles.includes('销售顾问')) {
            accessedRoutes = counselorRouters || [];
          } else if (userInfo.roles.length === 1 && userInfo.roles.includes('销售组长')) {
            accessedRoutes = dealerRoutes3 || []
          }
          else if (userInfo.roles.length === 2 && userInfo.roles.includes('销售组长') && userInfo.roles.includes('管理员')) {
            accessedRoutes = dealerRoutes4 || []
          } else if (userInfo.roles.length === 2 && userInfo.roles.includes('销售顾问') && userInfo.roles.includes('管理员')) {
            accessedRoutes = counselorRouters2 || []
          } else if (!userInfo.roles.includes('管理员')) {
            accessedRoutes = dealerRoutes2 || []
          } else {
            if (!userInfo.isMaster) {//小组长
              dealerRoutes.forEach((item, index) => {
                if (item.path == '/group') {
                  item.children.splice(0, 1);
                  item.children[0].meta.icon = 'delar';
                }
                if (item.path == '/examine') {
                  item.children = item.children.filter(val => val.name != 'callocation' && val.name != 'allocation');
                }
              })
            }
            accessedRoutes = dealerRoutes || [];
          }
          console.log(userInfo.roles,'userInfo.roles');
          
          if (userInfo.roles.includes('销售经理')) {
                  accessedRoutes = dealerRoutes5 || []
          }
        }
        commit('SET_ROUTES', accessedRoutes)
        resolve(accessedRoutes);
      })
    },
  }

}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js